<app-page-topbar [title]="'Form Templates'">
    <a *appDesktop class="button" (click)="createNewAssessmentForm()">
        New Form
    </a>
</app-page-topbar>

<app-template-list></app-template-list>
